// extracted by mini-css-extract-plugin
export var container = "_3h-1";
export var editor = "_3h-2";
export var resizable = "_3h-3";
export var wrapper = "_3h-0";